import Vue from 'vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { Application } from './application';
import { GraphView } from './graph/graphview';
import { TWEEN } from './graph/tween';


Vue.config.productionTip = false
Vue.component("graphview", GraphView)

/* make sure tween event loop is running */
function animate() {
    requestAnimationFrame(animate);
    TWEEN.update()
}
animate()

/* go! */
Application.instance = new Application({
    vuetify,
    router,
}).$mount("#app")

